// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_-kv","cls2":"DebugPage-cls2_MaH DebugPage-cls1_-kv"};